import some from 'lodash/some'
import React, { createContext, FC, useCallback, useEffect, useMemo, useState } from 'react'

interface BillwerkContextProviderProps {
  children: React.JSX.Element
}

interface BillwerkContextProps {
  billwerkInstance: any | null
}

export const BillwerkContext = createContext<BillwerkContextProps>({
  billwerkInstance: null,
})

const isScriptLoaded = (scriptUrl) => {
  const scripts = document.getElementsByTagName('script')
  return some(scripts, script => script.src.startsWith(scriptUrl))
}

export const BillwerkContextProvider: FC<BillwerkContextProviderProps> = ({ children }) => {
  const [billwerkInstance, setBillwerkInstance] = useState<unknown>(null)

  const initializeBillwerk = useCallback(async () => {
    // @ts-ignore
    const newBillwerkInstance = window.Reepay
    setBillwerkInstance(newBillwerkInstance)
  }, [])

  useEffect(() => {
    const scriptLoaded = isScriptLoaded('https://checkout.reepay.com/checkout.js')
    const head: HTMLHeadElement | null = document.querySelector('head')
    if (!head || scriptLoaded) {
      return
    }
    const script = document.createElement('script')
    script.setAttribute('src', 'https://checkout.reepay.com/checkout.js')
    head.appendChild(script)
    script.onload = () => initializeBillwerk()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const value = useMemo(
    () => ({ billwerkInstance }),
    [billwerkInstance],
  )

  return (
    <BillwerkContext.Provider value={value}>
      {children}
    </BillwerkContext.Provider>
  )
}
